export default "__VITE_ASSET__Bpomc4l___"